export default function($) {
  const eventDate = $('.js-countdown').data('countdown');
  const countDownDate = new Date(eventDate).getTime();

  var x = setInterval(function() {
    let now = new Date().getTime();

    var distance = countDownDate - now;

    var years = Math.floor(distance / (1000 * 60 * 60 * 24 * 365));
    var days = Math.floor((distance % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    $('.js-countdown-years').text(years)
    $('.js-countdown-days').text(days)
    $('.js-countdown-hours').text(hours)
    $('.js-countdown-minutes').text(minutes)
    $('.js-countdown-seconds').text(seconds)

    if (distance < 0) {
      clearInterval(x);
      $('.js-countdown-years').text(0)
      $('.js-countdown-days').text(0)
      $('.js-countdown-hours').text(0)
      $('.js-countdown-minutes').text(0)
      $('.js-countdown-seconds').text(0)
    }
  }, 1000);
}
